angular.module 'zc.master.zcliteKpi'

.controller 'MasterZcliteKpiCtrl', (
    $scope,
    $q,
    $translate,
    $filter,
    Page,
    ZcsKpi,
    ZcsAgencyInvoice,
    SearchFilter,
    agencies,
    projects,
    lib) ->

  Page.setBodyClass ''
  $translate('masterZclite.kpi.list.liteKpiManagement').then (translation) ->
    Page.setTitle translation

  DATE_FORMAT = 'YYYY-MM'
  THIS_MONTH = moment().format(DATE_FORMAT)
  THIS_PERIOD = moment(THIS_MONTH, DATE_FORMAT).toDate()
  CSV_HEADERS = [
    $translate.instant('masterZclite.kpi.list.title')
    $translate.instant('masterZclite.kpi.list.currentProjectsLength')
    $translate.instant('masterZclite.kpi.list.currentProjectPerformanceConversionPrice')
    $translate.instant('masterZclite.kpi.list.invoicePriceTaxEcluded')
    $translate.instant('masterZclite.kpi.list.retentionRate')
    $translate.instant('masterZclite.kpi.list.takeRate')
    $translate.instant('masterZclite.kpi.list.currentRegistered_projectsLength')
    $translate.instant('masterZclite.kpi.list.currentCorrected_registered_projects_count')
    $translate.instant('masterZclite.kpi.list.currentInstallationCompletionRatesSiteinfoConfirmed')
    $translate.instant('masterZclite.kpi.list.currentInstallationCompletionRatesConversionTagConfirmed')
    $translate.instant('masterZclite.kpi.list.currentInstallationCompletionRatesFirstCampaignStart')
    $translate.instant('masterZclite.kpi.list.currentCampaignStartedProjectsLength')
    $translate.instant('masterZclite.kpi.list.diffCampaignStartedProjects')
    $translate.instant('masterZclite.kpi.list.currentCampaignSettingProjectsLength')
    $translate.instant('masterZclite.kpi.list.diffCampaignSettingProjects')
    $translate.instant('masterZclite.kpi.list.currentCampaignDeliveryRatesSetting')
    $translate.instant('masterZclite.kpi.list.currentCampaignDeliveryRatesTerm')
    $translate.instant('masterZclite.kpi.list.currentCampaignCurrentProjectsLength')
    $translate.instant('masterZclite.kpi.list.diffCampaignCurrentProjects')
    $translate.instant('masterZclite.kpi.list.currentCampaignPerformance.sessionCoverRate')
    $translate.instant('masterZclite.kpi.list.currentCampaignPerformanceConversionCoverRate')
    $translate.instant('masterZclite.kpi.list.currentCampaignPerformanceConversionUpRate')
    $translate.instant('masterZclite.kpi.list.currentCampaignPerformanceCampaignCouponUsedRate')
  ]
  CSV_FIELDS = [
    'title'
    'current.projects.length'
    'current.project_performance.conversion_price'
    'invoice_price_tax_excluded'
    'take_rate'
    'retention_rate'
    'current.registered_projects.length'
    'current.corrected_registered_projects_count'
    'current.installation_completion_rates.siteinfo_confirmed'
    'current.installation_completion_rates.conversion_tag_confirmed'
    'current.installation_completion_rates.first_campaign_start'
    'current.campaign_started_projects.length'
    'diff.campaign_started_projects'
    'current.campaign_setting_projects.length'
    'diff.campaign_setting_projects'
    'current.campaign_delivery_rates.setting'
    'current.campaign_delivery_rates.term'
    'current.campaign_current_projects.length'
    'diff.campaign_current_projects'
    'current.campaign_performance.session_cover_rate'
    'current.campaign_performance.conversion_cover_rate'
    'current.campaign_performance.conversion_up_rate'
    'current.campaign_performance.campaign_coupon_used_rate'
  ]
  DIFF_KPIS = [
    'registered_projects.length'
    'corrected_registered_projects_count'
    'installation_completion_rates.siteinfo_confirmed'
    'installation_completion_rates.conversion_tag_confirmed'
    'installation_completion_rates.first_campaign_start'
    'campaign_started_projects.length'
    'campaign_setting_projects.length'
    'campaign_delivery_rates.setting'
    'campaign_delivery_rates.term'
    'campaign_current_projects.length'
    'campaign_performance.session_cover_rate'
    'campaign_performance.conversion_cover_rate'
    'campaign_performance.conversion_up_rate'
    'campaign_performance.campaign_coupon_used_rate'
  ]
  $scope.agencies = agencies
  $scope.projects = _.filter projects, (project) -> project.product_line == 'zenclerk_s' and not project.is_demo and not project.is_test

  $scope.filters = SearchFilter.resolveFromLocation()
  SearchFilter.setComponentDefaults 'masterZcliteKpi',
    sort_prop:
      default: 'title'
    sort_direction:
      default: 'asc'
    current_month:
      default: THIS_MONTH
  $scope.$on '$destroy', ->
    SearchFilter.removeComponentDefaults 'masterZcliteKpi'

  $scope.setSortProp = (key) ->
    if $scope.filters.sort_prop is key
      if $scope.filters.sort_direction is 'desc'
        $scope.filters.sort_direction = 'asc'
      else
        $scope.filters.sort_direction = 'desc'
    else
      $scope.filters.sort_prop = key
      $scope.filters.sort_direction = 'desc'
    updateData()

  $scope.nextMonth = ->
    return if $scope.is_tail_period
    $scope.current_period = moment($scope.current_period).add(1, 'month').toDate()
    $scope.filters.current_month = moment($scope.current_period).format(DATE_FORMAT)
    $scope.is_tail_period = isTailPeriod()
    $scope.filename = "kpi_#{moment($scope.current_period).format('YYYYMM')}.csv"
    updateData()

  $scope.prevMonth = ->
    $scope.current_period = moment($scope.current_period).subtract(1, 'month').toDate()
    $scope.filters.current_month = moment($scope.current_period).format(DATE_FORMAT)
    $scope.is_tail_period = isTailPeriod()
    $scope.filename = "kpi_#{moment($scope.current_period).format('YYYYMM')}.csv"
    updateData()

  $scope.filename = "kpi_#{moment(THIS_PERIOD).format('YYYYMM')}.csv"
  $scope.getCSV = ->
    csvData = []
    csvData.push CSV_HEADERS
    for agency in $scope.agencies
      csvData.push (lib.getField(agency, field) for field in CSV_FIELDS)
    csvData.push (lib.getField($scope.total, field) for field in CSV_FIELDS)
    csvData

  isTailPeriod = ->
    moment($scope.current_period).isSame(THIS_PERIOD)

  filterProjectsByAgency = (agency) ->
    _.filter $scope.projects, (project) -> project.agency_id is agency.id

  calculateDiff = (kpis1, kpis2) ->
    diff = {}
    for diff_kpi in DIFF_KPIS
      # Some props take array length of array, but for kpi props
      # we don't want the length to be there
      key = diff_kpi.replace('.length', '')
      kpi1 = lib.getField kpis1, diff_kpi
      kpi2 = lib.getField kpis2, diff_kpi
      if kpi1? and kpi2?
        diff[key] = kpi1 - kpi2
    diff

  updateData = ->
    SearchFilter.updateComponentDefaults 'masterZcliteKpi'
    is_desc = ($scope.filters.sort_direction == 'desc')
    $scope.agencies = $filter('orderBy')($scope.agencies, $scope.filters.sort_prop, is_desc)
    $scope.agencies = $filter('emptyToEnd')($scope.agencies, $scope.filters.sort_prop, is_desc)
    previous_period = moment($scope.current_period).subtract(1, 'month').toDate()
    agency_invoices = []
    agency_current_kpis = []
    agency_previous_kpis = []
    for agency in $scope.agencies
      agency_projects = filterProjectsByAgency(agency)
      agency_invoices.push(ZcsAgencyInvoice.find(agency.name, $scope.filters.current_month))
      agency_current_kpis.push(new ZcsKpi(agency_projects, $scope.current_period).calculate())
      agency_previous_kpis.push(new ZcsKpi(agency_projects, previous_period).calculate())
    $q.all
      total_current_kpi: new ZcsKpi($scope.projects, $scope.current_period).calculate()
      total_previous_kpi: new ZcsKpi($scope.projects, previous_period).calculate()
      agency_invoices: $q.all(agency_invoices)
      agency_current_kpis: $q.all(agency_current_kpis)
      agency_previous_kpis: $q.all(agency_previous_kpis)
    .then ({total_current_kpi, total_previous_kpi, agency_invoices, agency_current_kpis, agency_previous_kpis}) ->
      $scope.total =
        title: $filter('translate')('masterZclite.kpi.list.entire') # for csv
        invoice_price_tax_excluded: 0
      $scope.total.current = total_current_kpi
      $scope.total.previous = total_previous_kpi
      $scope.total.diff = calculateDiff($scope.total.current, $scope.total.previous)
      for agency, i in $scope.agencies
        agency.current = agency_current_kpis[i]
        agency.previous = agency_previous_kpis[i]
        agency.diff = calculateDiff(agency.current, agency.previous)

        # Sadly, invoice_price_tax_excluded is string format... ;(
        agency.invoice_price_tax_excluded = parseInt(agency_invoices[i].invoice_price_tax_excluded)

        if agency.current.project_performance.conversion_price > 0
          agency.take_rate = agency.invoice_price_tax_excluded / agency.current.project_performance.conversion_price
        else
          agency.take_rate = null
        if agency.previous.campaign_setting_projects.length
          retention_count = 0
          current_apikeys = _.map agency.current.campaign_setting_projects, 'apikey'
          for project in agency.previous.campaign_setting_projects
            retention_count += 1 if project.apikey in current_apikeys
          agency.retention_rate = retention_count / agency.previous.campaign_setting_projects.length
        else
          agency.retention_rate = null
        $scope.total.invoice_price_tax_excluded += agency.invoice_price_tax_excluded
      if $scope.total.current.project_performance.conversion_price > 0
        $scope.total.take_rate = $scope.total.invoice_price_tax_excluded / $scope.total.current.project_performance.conversion_price
      else
        $scope.total.take_rate = null
      if $scope.total.previous.campaign_setting_projects.length
        retention_count = 0
        current_apikeys = _.map $scope.total.current.campaign_setting_projects, 'apikey'
        for project in $scope.total.previous.campaign_setting_projects
          retention_count += 1 if project.apikey in current_apikeys
        $scope.total.retention_rate = retention_count / $scope.total.previous.campaign_setting_projects.length
      else
        $scope.total.retention_rate = null

  $scope.current_period = moment($scope.filters.current_month, DATE_FORMAT).toDate()
  $scope.is_tail_period = isTailPeriod()
  $scope.filename = "kpi_#{moment($scope.current_period).format('YYYYMM')}.csv"

  updateData()



// WEBPACK FOOTER //
// ./src/master_admin_modules/master.zclite_kpi/list.coffee